module.exports = __webpack_public_path__ + "img/GALLERY-FRONX-BOOSTERGREEN-5.30a0be9f.jpg";